export const initialValues = {
  logo: null,
  name: "",
  category_id: null,
  subcategory_id: null,
  owner_name: "",
  address: "",
  business_location: "",
  phone_number: "",
  wp_number: "",
  email: "",
  link: "",
  facebook_link: "",
  instagram_link: "",
  youtube_link: "",
  linkedin_link: "",
  is_active: 0,
  member_id: "",
  latitude: "",
  longitude: "",
  about: "",
  is_verified: 0,
  country_code: "",
  business_services: [
    {
      title: "",
      description: "",
      price: "",
      service_image: "",
    },
  ],
};
